<template>
  <section class="py-3">
    <label
      :for="'file-' + fileType"
      class="v-btn v-btn--depressed v-btn--flat v-btn--outlined theme--light v-size--default blue--text"
    >
      <v-icon small class="mr-3 blue--text">mdi-upload</v-icon>
      {{ fileName ? $t('buttons.changeFile') : $t('buttons.selectFile') }} 
    </label>
    <v-icon
      v-if="this.fileBytes"
      class="blue--text"
      @click="deleteFiles"
      >mdi-trash-can-outline</v-icon
    >
    <div v-if="errorMessage" class="red--text py-3">
      <v-icon small class="red--text">mdi-alert-circle-outline</v-icon>
      {{ errorMessage }}
    </div>
    <slot v-else></slot>
    <div v-if="fileName || file" class="grey--text py-3">
      <v-icon small class="grey--text">mdi-file</v-icon>
      {{ fileName || file.fileName }}
    </div>
    <input
      :id="'file-' + fileType"
      @change="changed"
      type="file"
      class="file"
    />
  </section>
</template>
<script>
export default {
  props: [
    // data
    "fileType",
    // settings
    "income",
    "file",
  ],
  data: () => ({
    // data
    fileSourceUrl: null,
    fileName: null,
    fileBytes: null,
    fileGuid: null,
    // settings
    errorMessage: null,
  }),
  created() {},
  methods: {
    transferData() {
      this.$emit("transferData", {
        fileType: this.fileType,
        fileSourceUrl: this.fileSourceUrl,
        fileName: this.fileName,
        fileBytes: this.fileBytes,
        fileGuid: this.fileGuid,
      });
    },
    deleteFiles() {
      this.fileBytes = null;
      this.fileSourceUrl = null;
      this.fileName = null;
      this.fileGuid = null;
      
      this.transferData();
      this.errorMessage = false;
    },
    fillPresetData(payload) {
      let keys = Object.keys(payload).filter((i) => i !== "fileType");
      keys.forEach((key) => {
        this[key] = payload[key];
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () =>
          resolve(reader.result ? reader.result.replace(/data.*,/, "") : "");
        reader.onerror = (error) => reject(error);
      });
    },
    changed(payload) {
      let file = payload.target.files[0];

      if (!file) {
        this.errorMessage = "Ошибка при чтении файла";
        return;
      }

        if(file.name.length >= 128){
          this.errorMessage = `Максимальная длина наименования файла - 128 символов. Ошибка в файле: ${file.name}`
          return
        }

      // Проверка на тип файла
      let availableFormats = [
        "jpg",
        "jpeg",
        "doc",
        "docx",
        "tiff",
        "gif",
        "pdf",
        "bmp",
      ];

      if (
        !availableFormats.some((item) => {
          return file.type.indexOf(item) > 0;
        })
      ) {
        this.errorMessage = "Неподходящий формат " + file.type;
        return;
      }

      if (file.size == 0) {
        this.errorMessage = "Размер файла не может быть 0 Кб";
        return;
      }
      // проверка на размер файла
      let availableSize = 5 * 1024 * 1024;
      if (file.size > availableSize) {
        this.errorMessage = "Размер файла слишком большой";
        return;
      } else {
        this.errorMessage = false;
      }

      // если проверки успешно пройдены
      this.getBase64(file)
        .then((response) => {
          this.fileName = file.name;
          this.fileBytes = response;

          this.transferData();
        })
        .catch((err) => {
          this.errorMessage = err;
        });
    },
  },
  watch: {
    income: {
      immediate: true,
      handler: function (value) {
        if (value !== null) {
          this.fillPresetData(value);
        }
      },
    },
  },
};
</script>

<style scooped>
input[type="file"] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
</style>
